import { mapKeys } from "lodash";
import moment from "moment";

import translate from "src/services/translate";

export type DaysOfWeekIds = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const MONDAY = 1;
export const TUESDAY = 2;
export const WEDNESDAY = 3;
export const THURSDAY = 4;
export const FRIDAY = 5;
export const SATURDAY = 6;
export const SUNDAY = 7;
export const SUNDAY_FIRST = 0;

export type DaysOfWeekShortCodes = "M" | "T" | "W" | "R" | "F" | "S" | "U";

export const MONDAY_SHORTCODE = "M";
export const TUESDAY_SHORTCODE = "T";
export const WEDNESDAY_SHORTCODE = "W";
export const THURSDAY_SHORTCODE = "R";
export const FRIDAY_SHORCUT = "F";
export const SATURDAY_SHORTCODE = "S";
export const SUNDAY_SHORTCODE = "U";

export const FIRST_TYPE_ID = 1;
export const LAST_TYPE_ID = 6;

export type Weekday = {
  id: DaysOfWeekIds;
  shortCode: DaysOfWeekShortCodes;
  name: string;
  shortCodeName: string;
};

export const WEEKDAYS: Weekday[] = [
  {
    id: MONDAY,
    shortCode: MONDAY_SHORTCODE,
    name: translate("common.weekdays.monday"),
    shortCodeName: translate("common.weekdayShortCodes.monday"),
  },
  {
    id: TUESDAY,
    shortCode: TUESDAY_SHORTCODE,
    name: translate("common.weekdays.tuesday"),
    shortCodeName: translate("common.weekdayShortCodes.tuesday"),
  },
  {
    id: WEDNESDAY,
    shortCode: WEDNESDAY_SHORTCODE,
    name: translate("common.weekdays.wednesday"),
    shortCodeName: translate("common.weekdayShortCodes.wednesday"),
  },
  {
    id: THURSDAY,
    shortCode: THURSDAY_SHORTCODE,
    name: translate("common.weekdays.thursday"),
    shortCodeName: translate("common.weekdayShortCodes.thursday"),
  },
  {
    id: FRIDAY,
    shortCode: FRIDAY_SHORCUT,
    name: translate("common.weekdays.friday"),
    shortCodeName: translate("common.weekdayShortCodes.friday"),
  },
  {
    id: SATURDAY,
    shortCode: SATURDAY_SHORTCODE,
    name: translate("common.weekdays.saturday"),
    shortCodeName: translate("common.weekdayShortCodes.saturday"),
  },
  {
    id: SUNDAY,
    shortCode: SUNDAY_SHORTCODE,
    name: translate("common.weekdays.sunday"),
    shortCodeName: translate("common.weekdayShortCodes.sunday"),
  },
];

export const WEEKDAYS_STARTING_SUNDAY: Weekday[] = [
  {
    id: MONDAY,
    shortCode: MONDAY_SHORTCODE,
    name: translate("common.weekdays.monday"),
    shortCodeName: translate("common.weekdayShortCodes.monday"),
  },
  {
    id: TUESDAY,
    shortCode: TUESDAY_SHORTCODE,
    name: translate("common.weekdays.tuesday"),
    shortCodeName: translate("common.weekdayShortCodes.tuesday"),
  },
  {
    id: WEDNESDAY,
    shortCode: WEDNESDAY_SHORTCODE,
    name: translate("common.weekdays.wednesday"),
    shortCodeName: translate("common.weekdayShortCodes.wednesday"),
  },
  {
    id: THURSDAY,
    shortCode: THURSDAY_SHORTCODE,
    name: translate("common.weekdays.thursday"),
    shortCodeName: translate("common.weekdayShortCodes.thursday"),
  },
  {
    id: FRIDAY,
    shortCode: FRIDAY_SHORCUT,
    name: translate("common.weekdays.friday"),
    shortCodeName: translate("common.weekdayShortCodes.friday"),
  },
  {
    id: SATURDAY,
    shortCode: SATURDAY_SHORTCODE,
    name: translate("common.weekdays.saturday"),
    shortCodeName: translate("common.weekdayShortCodes.saturday"),
  },
  {
    id: SUNDAY_FIRST,
    shortCode: SUNDAY_SHORTCODE,
    name: translate("common.weekdays.sunday"),
    shortCodeName: translate("common.weekdayShortCodes.sunday"),
  },
];

export const WEEKDAYS_BY_ID = mapKeys(WEEKDAYS, "id");
export const WEEKDAYS_BY_SHORTCODE = mapKeys(WEEKDAYS, "shortCode");

export const TODAY = moment().toDate();
export const TODAY_FORMATTED = moment().format("MM/DD/YYYY");
export const TODAY_END_OF_DAY = moment().endOf("day");
export const YESTERDAY = moment().subtract(1, "days").format("MM/DD/YYYY");
export const TOMORROW = moment().add(1, "days").format("MM/DD/YYYY");

export const DEFAULT_TIME = "00:00:00";

export const MAX_SEARCHABLE_MONTHS = 6;
